import { useState } from 'react'

export const useSorterButtons = <T>(defaultSorter: T) => {
  const [currentSorterId, setSorterId] = useState<T>(defaultSorter)

  return { currentSorterId, setSorterId }
}
